import React, { Component } from 'react';
import { Modal } from 'reactstrap';

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        const isError = this.props.errorValues === false;

        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-pen"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="rk-modal__body">
                        <div className="rk-field">
                            <label className="rk-label">Nombre</label>
                            <input
                                type="text"
                                name="name"
                                value={this.props.formValues.name}
                                onChange={this.props.onChangeForm}
                                className={`rk-input ${isError && this.props.formValues.name == "" ? "rk-input--error" : ""}`}
                                placeholder="Escribe un nombre"
                            />
                        </div>

                        {isError && (
                            <div className="rk-alert">
                                <i className="fas fa-exclamation-circle"></i>
                                Debes completar todos los campos requeridos
                            </div>
                        )}
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                            Cerrar
                        </button>
                        <button
                            type="button"
                            className="rk-btn rk-btn--primary"
                            onClick={this.props.submitForm}
                            disabled={this.props.isLoaded}
                        >
                            {this.props.isLoaded
                                ? <><i className="fas fa-spinner fa-spin"></i> Cargando…</>
                                : <><i className="fas fa-check"></i> {this.props.nameBnt}</>}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default FormCreate;
